<template>
  <el-dialog v-dialogDrag title="邀请好友" :visible.sync="show" width="620px" :before-close="close">
    <div class="add-group-member">
      <div class="left-box">
        <el-input placeholder="搜索好友" v-model="searchText" size="small">
          <i class="el-icon-search el-input__icon" slot="suffix"> </i>
        </el-input>
        <div class="select-all-container">
          <el-checkbox
              v-model="selectAllChecked"
              @change="onSelectAllChange"
              :indeterminate="isIndeterminate">
            全选
          </el-checkbox>
          <span class="select-count">已选 {{ checkCount }}/50</span>
        </div>
        <el-scrollbar style="height:400px;">
          <div v-for="friend in friends" :key="friend.id">
            <friend-item v-show="friend.showNickName.includes(searchText)" @click.native="onSwitchCheck(friend)"
                         :menu="false" :friend="friend" size="small">
              <el-checkbox @click.native.stop="" class="checkbox"
                           v-model="friend.isCheck"></el-checkbox>
            </friend-item>
          </div>
        </el-scrollbar>
      </div>
      <div class="arrow el-icon-d-arrow-right"></div>
      <div class="right-box">
        <div class="tip"> 已勾选{{ checkCount }}位好友</div>
        <el-scrollbar style="height:400px;">
          <div v-for="friend in friends" :key="friend.id">
            <friend-item v-if="friend.isCheck" :friend="friend" size="small"
                         @del="onRemoveFriend(friend)" :menu="false">
            </friend-item>
          </div>
        </el-scrollbar>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close()">取 消</el-button>
      <el-button type="primary" @click="onOk()">确 定</el-button>
    </span>
  </el-dialog>
</template>


<script>
import FriendItem from '../friend/FriendItem.vue';

export default {
  name: "addGroupMember",
  components: {
    FriendItem
  },
  data() {
    return {
      show: false,
      searchText: "",
      friends: [],
      selectAllChecked: false,
      isIndeterminate: false
    }
  },
  methods: {
    open() {
      this.show = true;
      this.friends = [];
      this.selectAllChecked = false;
      this.isIndeterminate = false;
      this.friendStore.friends.forEach((f) => {
        if (f.deleted) {
          return;
        }
        let friend = JSON.parse(JSON.stringify(f))
        let m = this.members.filter((m) => !m.quit).find((m) => m.userId == f.id);
        if (m) {
          // 好友已经在群里，不添加到列表中
          return;
        } else {
          friend.disabled = false;
          friend.isCheck = false;
        }
        this.friends.push(friend);
      })
    },
    close() {
      this.show = false;
    },
    onOk() {
      let inviteVO = {
        groupId: this.groupId,
        friendIds: []
      }
      this.friends.forEach((f) => {
        if (f.isCheck && !f.disabled) {
          inviteVO.friendIds.push(f.id);
        }
      })
      if (inviteVO.friendIds.length > 0) {
        this.$http({
          url: "/group/invite",
          method: 'post',
          data: inviteVO
        }).then(() => {
          this.$message.success("邀请成功");
          this.$emit("reload");
          this.close()
        })
      }
    },
    onRemoveFriend(friend) {
      friend.isCheck = false;
      this.updateSelectAllState();
    },
    onSwitchCheck(friend) {
      if (!friend.disabled) {
        friend.isCheck = !friend.isCheck
        this.updateSelectAllState();
      }
    },
    onSelectAllChange(val) {
      const selectableFriends = this.friends.filter(f => !f.disabled &&
          f.showNickName.includes(this.searchText));

      if (val) {
        // 全选时最多选50个
        const maxSelectable = 50 - this.friends.filter(f => f.isCheck && f.disabled).length;
        selectableFriends.slice(0, maxSelectable).forEach(friend => {
          friend.isCheck = true;
        });

        // 如果还有未选中的，则设置为部分选中状态
        if (selectableFriends.length > maxSelectable) {
          this.isIndeterminate = true;
        } else {
          this.isIndeterminate = false;
        }
      } else {
        // 取消全选
        selectableFriends.forEach(friend => {
          friend.isCheck = false;
        });
        this.isIndeterminate = false;
      }
    },
    updateSelectAllState() {
      const selectableFriends = this.friends.filter(f => !f.disabled &&
          f.showNickName.includes(this.searchText));
      const checkedCount = this.friends.filter(f => f.isCheck && !f.disabled &&
          f.showNickName.includes(this.searchText)).length;

      if (checkedCount === 0) {
        this.selectAllChecked = false;
        this.isIndeterminate = false;
      } else if (checkedCount >= selectableFriends.length) {
        this.selectAllChecked = true;
        this.isIndeterminate = false;
      } else {
        this.selectAllChecked = false;
        this.isIndeterminate = true;
      }
    }
  },
  props: {
    groupId: {
      type: Number
    },
    members: {
      type: Array
    }
  },
  computed: {
    checkCount() {
      return this.friends.filter((f) => f.isCheck && !f.disabled).length;
    }
  },
  watch: {
    searchText() {
      this.$nextTick(() => {
        this.updateSelectAllState();
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.add-group-member {
  display: flex;

  .left-box {
    flex: 1;
    overflow: hidden;
    border: var(--im-border);

    .select-all-container {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 8px 10px;
      border-bottom: var(--im-border);

      .select-count {
        font-size: 12px;
        color: var(--im-text-color-light);
      }
    }

    .checkbox {
      margin-right: 10px;
    }
  }

  .arrow {
    display: flex;
    align-items: center;
    font-size: 18px;
    padding: 10px;
    color: var(--im-color-primary);
  }

  .right-box {
    flex: 1;
    border: var(--im-border);

    .tip {
      text-align: left;
      height: 32px;
      line-height: 32px;
      text-indent: 10px;
      color: var(--im-text-color-light)
    }
  }
}
</style>
